import ChartBase from "./ChartBase";
export default class ChartSSC extends ChartBase {
    parse(data) {
        let pattern = /#([a-z]+):(.*?);/gis;
        let temp = { notes: [] };
        let chart_id = -1;
        let match;
        while (match = pattern.exec(data)) {
            match[1] = match[1].toLowerCase();
            if (match[1] == "notedata") {
                chart_id++;
                temp["notes"][chart_id] = {};
                continue;
            }
            if (chart_id > -1) {
                switch (match[1]) {
                    // time=string
                    case 'labels':
                    case 'speeds':
                    case 'timesignatures':
                        temp["notes"][chart_id][match[1]] = this.getListValues(match[2], false);
                        break;
                    // time=value
                    case 'bpms':
                    case 'stops':
                    case 'delays':
                    case 'warps':
                    case 'tickcounts':
                    case 'combos':
                    case 'scrolls':
                        temp["notes"][chart_id][match[1]] = this.getListValues(match[2], true);
                        break;
                    case 'notes':
                        // filter out anything except notes and commas
                        let notesData = match[2].split(/(\r\n|\n|\r)/);
                        for (let i = 0; i < notesData.length; i++) {
                            let pos = notesData[i].indexOf('//');
                            if (pos !== -1)
                                notesData[i] = notesData[i].substring(0, pos);
                            notesData[i] = notesData[i].trim();
                        }
                        temp["notes"][chart_id]['data'] = notesData.join('');
                        break;
                    default:
                        if (ChartSSC.fields_number.indexOf(match[1]) != -1)
                            temp["notes"][chart_id][match[1]] = parseFloat(match[2]);
                        else
                            temp["notes"][chart_id][match[1]] = match[2];
                        break;
                }
            }
            else {
                switch (match[1]) {
                    // time=string
                    case 'labels':
                    case 'speeds':
                    case 'timesignatures': {
                        let tmp_array = this.getListValues(match[2], false);
                        if (tmp_array.length > 0)
                            temp[match[1]] = tmp_array;
                        break;
                    }
                    // time=value
                    case 'bpms':
                    case 'stops':
                    case 'delays':
                    case 'warps':
                    case 'tickcounts':
                    case 'combos':
                    case 'scrolls': {
                        let tmp_array = this.getListValues(match[2], true);
                        if (tmp_array.length > 0)
                            temp[match[1]] = tmp_array;
                        break;
                    }
                    default:
                        if (ChartSSC.fields_number.indexOf(match[1]) != -1)
                            temp[match[1]] = parseFloat(match[2]);
                        else
                            temp[match[1]] = match[2];
                        break;
                }
            }
        }
        // Standardize Output
        this.info = {
            title: temp.title,
            titleTranslit: temp.titletranslit,
            subtitle: temp.subtitle,
            subtitleTranslit: temp.subtitletranslit,
            artist: temp.artist,
            artistTranslit: temp.artisttranslit,
            credit: temp.credit,
            creditBanner: temp.cdtitle,
            banner: temp.banner,
            background: temp.background,
            music: temp.music,
            offset: temp.offset,
            sampleStart: temp.samplestart,
            sampleLength: temp.samplelength,
            bpms: temp.bpms,
            stops: temp.stops
        };
        if (chart_id == -1) {
            this.charts.push({
                columns: this.smStandardType(temp.stepstype),
                difficulty: temp.meter,
                name: temp.difficulty,
                timeline: undefined
            });
        }
        else {
            for (const chart_val of temp.notes) {
                this.charts.push({
                    columns: this.smStandardType(chart_val.stepstype),
                    difficulty: chart_val.meter,
                    name: chart_val.difficulty,
                    timeline: undefined
                });
            }
            ;
        }
        // Set Types
        this._validTypes = 0;
        return true;
    }
    smStandardType(type) {
        switch (type) {
            case 'dance-single':
                return 4;
            case 'dance-double':
            case 'dance-couple':
            case 'dance-routine':
                return 8;
            case 'dance-solo':
            case 'pump-halfdouble':
                return 6;
            case 'pump-single':
                return 5;
            case 'pump-double':
            case 'pump-couple':
                return 10;
        }
        return 0;
    }
    getListValues(input, isNumber) {
        let output = [];
        if (input.length == 0)
            return output;
        let arrayValues = input.split(',');
        if (arrayValues.length == 0)
            return output;
        arrayValues.forEach((item) => {
            item = item.trim();
            let splitIndex = item.indexOf("=");
            if (splitIndex >= 1) {
                let beat = Math.round(parseFloat(item.substring(0, splitIndex)) * 48) / 48;
                let value = isNumber ? parseFloat(item.substring(splitIndex + 1)) : item.substring(splitIndex + 1);
                output.push([beat, value]);
            }
        });
        return output;
    }
}
ChartSSC.fields_number = [
    'offset',
    'samplestart',
    'samplelength',
    'version',
    'meter'
];
